import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from '@common/App.vue';
import { VueDraggableNext } from 'vue-draggable-next';
import Erreur from '@common/components/ulaval-custom/Erreur.vue';
import vuetify from '@common/plugins/vuetify';
import '@common/scss/style.scss';


import PerfectScrollbar from 'vue3-perfect-scrollbar';
import VueApexCharts from 'vue3-apexcharts';
import VueTablerIcons from 'vue-tabler-icons';
import { fakeBackend } from '@common/utils/helpers/fake-backend';
import 'vue3-carousel/dist/carousel.css';
//Mock Api data
import './_mockApis';
// print
// import print from 'vue3-print-nb';
// Table
import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';

import VCalendar from 'v-calendar';
import VueRecaptcha from 'vue3-recaptcha-v2';
import Maska from 'maska';
// print
// import print from 'vue3-print-nb';
// Table

import 'vue3-easy-data-table/dist/style.css';
import VueScrollTo from 'vue-scrollto';


import router from '@common/router/router';
import { useAuthStore } from '@common/store/auth';
import moment from "moment";
import ApiService  from "@common/services/api.service";

// Importer le fichier CSS de Bootstrap
//import 'bootstrap/dist/css/bootstrap.min.css';

// Importer le fichier JS de Bootstrap
//import 'bootstrap/dist/js/bootstrap.min.js';

// Importer Popper.js (même s'il est intégré dans le bundle, c'est pour assurer la version)
import { createPopper } from '@popperjs/core';

// main.js
import '@mdi/font/css/materialdesignicons.css';

import { createI18n } from 'vue-i18n';


import axios from 'axios';
import VueAxios from 'vue-axios';

import config from "./views/config";
import {getPortailService, setPortailService} from "@common/services/portail.service";



const appId = import.meta.env.VITE_APP_ID;

let Portail = null;
let Router = null;

async function initializeApp() {
    try {
        if (appId === 'cursul') {
            Portail = (await import('@cursul/portail.service')).default;
            Router = (await import('@cursul/router/router')).default;
        } else if (appId === 'figs') {
            Portail = (await import('@figs/portail.service')).default;
            Router = (await import('@figs/router/router')).default;
        } else if (appId === 'djo') {
            Portail = (await import('@djo/portail.service')).default;
            Router = (await import('@djo/router')).default;
        } else {
            throw new Error(`VITE_APP_ID invalide : ${appId}`);
        }

        setPortailService(Portail);

        const i18n = createI18n({
            legacy: false,
            locale: 'fr',
            fallbackLocale: 'en',
            messages: {
                en: { message: 'Hello' },
                fr: { message: 'Bonjour' }
            }
        });

        const app = createApp(App);

        // Conserver l’instance Pinia
        const pinia = createPinia();

        // Installer Pinia avant tout appel à use...Store()
        app.use(pinia);

        /*
         * chargerConfiguration() utilise useAuthStore(),
         * useMenuStore() et useDefinitionApplicationStore().
         * Pinia doit donc être actif avant cet appel.
         */
        await getPortailService().chargerConfiguration();

        app.use(VueAxios, axios);

        app.config.globalProperties.$axios = axios;
        app.config.globalProperties.$moment = moment;
        app.config.globalProperties.$api = ApiService;

        app.use(i18n);
        app.use(Router);
        app.use(vuetify);

        app.component('EasyDataTable', Vue3EasyDataTable);
        app.component('VueDraggableNext', VueDraggableNext);

        app.use(PerfectScrollbar);
        app.use(VCalendar, {});
        app.use(VueTablerIcons);

        app.use(VueRecaptcha, {
            siteKey: '6LdzqbcaAAAAALrGEZWQHIHUhzJZc8O-KSTdTTh_',
            alterDomain: false
        });

        app.use(Maska);
        app.use(VueApexCharts);

        app.use(VueScrollTo, {
            duration: 1000,
            easing: 'ease'
        });

        app.mount('#app');

        window.vm = app;
    } catch (err) {
        console.error('Erreur pendant l’initialisation :', err);

        const errorApp = createApp(Erreur);
        errorApp.use(vuetify);
        errorApp.mount('#app');
    }
}

initializeApp();

//app.use(VueI18n)